var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.workflowloading,
          expression: "workflowloading"
        }
      ],
      attrs: {
        visible: _vm.workflowVisible,
        width: "90%",
        top: "5vh",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.workflowVisible = $event
        },
        close: _vm.CloseWorkflow
      }
    },
    [
      _c("div", { staticStyle: { height: "80vh" } }, [
        _c("iframe", {
          attrs: {
            src: _vm.workflowUrl,
            width: "100%",
            height: "100%",
            frameborder: "0"
          },
          on: { load: _vm.WorkflowDetailOnload }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69ac53c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ac53c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkflowApplyDetail.vue
// module id = null
// module chunks = 